// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__zQhvT","head":"ProcedureTableInfo_head__1RZLQ"};